module.exports = __webpack_public_path__ + "img/hardwareOpen8.ea3ad579.png";